import type { CountryConfig } from './typing';

export const statements: CountryConfig = {
    enabled: true,
    createStatement: true,
    deliveryDefinitions: {
        distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
        format: ['PDF_A4', 'XML_SEPA', 'TXT_MT940'],
        periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
        canCreateDefinition: true,
        statementNumberEditable: true,
    },
    tableColumns: [
        { id: 'name', label: 'main.settings.name', width: '25%' },
        { id: 'time-span', label: 'account.statements.timeFrame', width: '40%' },
        { id: 'bank-signed', label: '', width: '20%' },
        { id: 'download-options', label: '', width: '15%' },
    ],
    showHelpCenterInfoBox: true,
    showMultiDownloadCard: true,
    showDownloadOptions: true,
};
